import { ProductTypeHelper, ProductQueryParam, ResponseStatus, store } from 'ltur-state-engine';
export function checkStateFulfilledForSearchMask(lturState) {
    return (typeof lturState !== 'undefined'
        && lturState !== null
        && typeof lturState.websiteState.searchMask.searchMaskBundle !== 'undefined'
        && lturState.websiteState.searchMask.searchMaskBundle !== null
        && typeof lturState.websiteState.searchMask.searchMaskBundle.groups !== 'undefined'
        && lturState.websiteState.searchMask.searchMaskBundle.groups !== null
        && typeof lturState.coreState.package.formData !== 'undefined'
        && lturState.coreState.package.formData !== null
        && typeof lturState.coreState.hotel.formData !== 'undefined'
        && lturState.coreState.hotel.formData !== null);
}
export function checkStateFulfilledForVerticalFilter(lturState) {
    return (typeof lturState !== 'undefined'
        && lturState !== null
        && typeof lturState.websiteState.searchMask.searchMaskBundle !== 'undefined'
        && lturState.websiteState.searchMask.searchMaskBundle !== null
        && typeof lturState.websiteState.searchMask.searchMaskBundle.groups !== 'undefined'
        && lturState.websiteState.searchMask.searchMaskBundle.groups !== null
        && typeof lturState.coreState.package.formData !== 'undefined'
        && lturState.coreState.package.formData !== null
        && typeof lturState.coreState.hotel.formData !== 'undefined'
        && lturState.coreState.hotel.formData !== null);
}
export function checkStateFulfilledForGroupQueryOptions(lturState) {
    var _a, _b;
    return (((_a = lturState.coreState.package.groupQueryOptions) === null || _a === void 0 ? void 0 : _a.get('default').status) === ResponseStatus.SUCCEED
        || ((_b = lturState.coreState.hotel.groupQueryOptions) === null || _b === void 0 ? void 0 : _b.get('default').status) === ResponseStatus.SUCCEED);
}
export function checkStateFulfilledForQueryOptions(lturState) {
    var _a, _b;
    return ![ResponseStatus.LOADING, ResponseStatus.INIT, ResponseStatus.LAZY_LOADING].includes((_a = lturState.coreState.package.queryOptions) === null || _a === void 0 ? void 0 : _a.get('default').status)
        || ![ResponseStatus.LOADING, ResponseStatus.INIT, ResponseStatus.LAZY_LOADING].includes((_b = lturState.coreState.hotel.queryOptions) === null || _b === void 0 ? void 0 : _b.get('default').status);
}
export function checkStateFulfilledForHorizontalFilter(lturState) {
    return (typeof lturState !== 'undefined'
        && lturState !== null
        && typeof lturState.websiteState.searchMask.searchMaskBundle !== 'undefined'
        && lturState.websiteState.searchMask.searchMaskBundle !== null
        && typeof lturState.websiteState.searchMask.searchMaskBundle.groups !== 'undefined'
        && lturState.websiteState.searchMask.searchMaskBundle.groups !== null
        && typeof lturState.websiteState.app !== 'undefined'
        && lturState.websiteState.app !== null
        && typeof lturState.websiteState.app.url !== 'undefined'
        && lturState.websiteState.app.url !== null
        && typeof lturState.websiteState.app.url.context !== 'undefined'
        && lturState.websiteState.app.url.context !== null);
}
export function checkStateFulfilledForDatesAndPrices(lturState) {
    return (typeof lturState !== 'undefined'
        && lturState !== null
        && typeof lturState.websiteState.searchMask.searchMaskBundle !== 'undefined'
        && lturState.websiteState.searchMask.searchMaskBundle !== null
        && typeof lturState.websiteState.searchMask.searchMaskBundle.groups !== 'undefined'
        && lturState.websiteState.searchMask.searchMaskBundle.groups !== null
        && typeof lturState.websiteState.app.translations !== 'undefined'
        && lturState.websiteState.app.translations !== null
        && typeof lturState.websiteState.app.url !== 'undefined'
        && lturState.websiteState.app.url !== null
        && typeof lturState.websiteState.app.url.context !== 'undefined'
        && lturState.websiteState.app.url.context !== null);
}
export function getOptionsFromFormData(optionGroupId) {
    var lturState = store.getState();
    var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(lturState.websiteState.app.url.context.productType);
    var formDataResponse = lturState.coreState[coreStateGroup].formData;
    if (formDataResponse && formDataResponse.optionGroups) {
        var optionGroup = formDataResponse.optionGroups.filter(function (group) {
            return group.id === optionGroupId;
        });
        if (optionGroup && optionGroup.length > 0) {
            return optionGroup[0].options;
        }
    }
    return null;
}
export function getQueryFromFormData(optionId) {
    var option = getOptionFromFormData(optionId);
    if (option) {
        return option.queryParams;
    }
    return null;
}
export function getNameFromFormData(optionId) {
    var option = getOptionFromFormData(optionId);
    if (option) {
        return option.name;
    }
    return null;
}
export function getOptionFromFormData(optionId) {
    var optionGroupId = optionId - (optionId % 100);
    var options = getOptionsFromFormData(optionGroupId);
    if (options && options.length > 0) {
        var filteredOptions = options.filter(function (option) { return option.id == optionId; });
        if (filteredOptions && filteredOptions.length > 0) {
            return filteredOptions[0];
        }
    }
    return null;
}
export function getFacetFromGroupResponse(destinationType, optionId) {
    var queryObject = getQueryFromFormData(optionId);
    var attribute = null;
    if (queryObject && queryObject[ProductQueryParam.HOTEL_ATTRIBUTES] && Array.isArray(queryObject[ProductQueryParam.HOTEL_ATTRIBUTES])) {
        attribute = queryObject[ProductQueryParam.HOTEL_ATTRIBUTES][0];
    }
    var lturState = store.getState();
    var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(lturState.websiteState.app.url.context.productType);
    if (attribute && lturState.coreState[coreStateGroup].groups.get(destinationType) && lturState.coreState[coreStateGroup].groups.get(destinationType).facets) {
        var facets = lturState.coreState[coreStateGroup].groups.get(destinationType).facets;
        if (facets.length > 0) {
            var index = facets.map(function (facet) { return facet.fieldValue; }).indexOf(attribute);
            if (index && index >= 0) {
                return facets[index];
            }
        }
    }
    return null;
}
